export const DRAWER_DROP_TARGET_ID = "drawer"

export const TRASH_CAN_DROP_TARGET_ID = "trash-can"

export const LEGACY_METRICS_SECTION_ID = "client-portal-metrics-section"
